module.exports = __webpack_public_path__ + "static/img/gfbk9.b6a1f849.png";